import React from 'react';
import '../styles/pages/AboutUsPage.css';

const AboutUsPage = () => {
  return (
    <div className="about-us-page-container">
      <h1>About Us</h1>
      <section className="about-us-content">
        <p>
          Hi, I’m Michele—and I run a small cookie business.
        </p>
        <p>
          Like so many decorators, I fell in love with the art of cookies: mixing colors, piping details, bringing designs to life. But there was always one part of the process I dreaded… the icing math.
        </p>
        <p>
          Every order meant pulling out a spreadsheet (with formulas I barely understood) or scribbling numbers on scraps of paper, trying to guess how much royal icing I needed. Too much? Waste. Too little? Stress. It took up precious time I could’ve spent actually decorating.
        </p>
        <p>
          That’s when my husband—who loves solving problems—stepped in.
        </p>
        <p>
          He saw how much time and frustration went into the calculating, and he built The Icing Calculator to make it simple. No more spreadsheets. No more guesswork. Just a clean, easy-to-use tool that helps me figure out exactly how much icing I need for any project.
        </p>
        <p>
          What started as a tool for me quickly became something I knew could help other cookiers, too. That’s why we decided to share it.
        </p>
        <p>
          Today, The Icing Calculator helps decorators everywhere spend less time calculating and more time creating. The Basic Calculator is free, and we offer a Pro version for those who want extra features—plus a tip jar for anyone who wants to help keep the free tool going.
        </p>
        <p>
          Thanks for being here. I hope this little tool makes your cookie life just a bit easier, like it did for me.
        </p>
      </section>
    </div>
  );
};

export default AboutUsPage;
